import { RugbyLeagueIncidentId } from '@collector/sportsapi-client-legacy'

import { FieldClickCoordinatesIncidentConfig } from '../../../configuration'

export const fieldClickCoordinatesIncidentConfig: FieldClickCoordinatesIncidentConfig<RugbyLeagueIncidentId> =
  {
    forceCreateIncidentIds: [],
    getIncidentToUpdateCoordinates: {
      [RugbyLeagueIncidentId.EntryInto20]: (incidents) => {
        const lastEntryInto20IncidentIndex = incidents.findIndex(
          (incident) =>
            incident.incident_id === RugbyLeagueIncidentId.EntryInto20,
        )
        if (lastEntryInto20IncidentIndex === -1) return
        const lastEntryInto20Incident = incidents[lastEntryInto20IncidentIndex]
        for (let i = 0; i < lastEntryInto20IncidentIndex; i++) {
          const incident = incidents[i]
          if (
            (incident.participant_team_id !==
              lastEntryInto20Incident.participant_team_id &&
              incident.incident_id !== RugbyLeagueIncidentId.TackleMade) ||
            incident.incident_id === RugbyLeagueIncidentId.InPossession
          ) {
            return
          }
        }
        return lastEntryInto20Incident
      },
    },
  }
